import React, { useContext } from "react";
import { InputAdornment, TextField } from "@mui/material";
import FontDownloadIcon from "@mui/icons-material/FontDownload";
import { useSelector } from "react-redux";
import { ModuleContext } from "../utils/Constants";
import { isComponentDisabled, isComponentVisible } from "../utils/SaitUtils";
import { useTheme, alpha } from "@mui/material/styles";

export default function SaitTextField(props) {
	const theme = useTheme();

	const { noAutocomplete, password, searchWindow, name, defaultValues, ...textProps } = props;
	const defaultSize = "small";

	const componentModule = useContext(ModuleContext);
	const objModArray = useSelector((state) => state["auth"]["objMod"]);
	const objMod = objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === textProps.objmod);

	const [isCapsLockOn, setIsCapsLockOn] = React.useState(false);

	const checkCapsLock = (event) => {
		setIsCapsLockOn(event.getModifierState("CapsLock"));
	};

	const handleBlur = () => {
		setIsCapsLockOn(false);
	};

	return isComponentVisible(objMod, textProps.hidden) ? (
		<TextField
			{...textProps}
			name={Array.isArray(name) ? name[0] : name}
			type={textProps.type ? textProps.type : password ? "password" : "text"}
			size={textProps.size || defaultSize}
			onKeyDown={(event) => {
				event.stopPropagation();
				textProps.onKeyDown ? textProps.onKeyDown(event) : password ? checkCapsLock(event) : null;
			}}
			onBlur={password ? handleBlur : null}
			disabled={isComponentDisabled(objMod, textProps.disabled)}
			sx={{
				...textProps.sx,
				...(!searchWindow && {
					"& .MuiOutlinedInput-root.Mui-disabled": {
						backgroundColor: alpha(theme.palette.text.primary, 0.05),
						borderRadius: 1,
					},
				}),
				"& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input.Mui-disabled": {
					color: theme.palette.text.primary, // colore testo più scuro
					WebkitTextFillColor: theme.palette.text.primary, // forza colore su Chrome/Edge
					opacity: 0.8,
				},
				"& .MuiInputLabel-root.Mui-disabled": {
					color: theme.palette.text.secondary,
				},
				"& .MuiInputBase-root:has(> input[type='password']:-webkit-autofill)": {
					backgroundColor: theme.palette["autofill"]?.main,
				},
				background: props.backgroundColor,
			}}
			slotProps={{
				input: {
					endAdornment: textProps.endadornment,
					startAdornment: textProps.startadornment,
					...(password && isCapsLockOn
						? {
								endAdornment: (
									<InputAdornment position="end">
										<FontDownloadIcon />
									</InputAdornment>
								),
							}
						: {}), // Un oggetto vuoto se la condizione non è soddisfatta
				},

				htmlInput: {
					minLength: textProps.minLength,
					maxLength: textProps.maxLength,
					autoComplete: noAutocomplete ? "new-password" : props.autoComplete,
					...(props.type === "number" && textProps.maxLength
						? {
								onInput: (e) => {
									if (e.target.value.length > e.target.maxLength) {
										e.target.value = e.target.value.slice(0, e.target.maxLength);
									}
								},
							}
						: {}),
				},
			}}
		/>
	) : null;
}
